import { Maybe } from '../../common/types'
import { TowingRecordRoute } from '../../containers/TowingRecordPage/components/SummaryBody/types'
import { Coords } from '../../common/types'

export const parseAddress = (address: string | null, city: string | null): string => {
  if (!address && !city) return ''
  if (address && !city) return address
  if (!address && city) return city
  return `${address}, ${city}`
}

type GenericRoute = Partial<TowingRecordRoute> & {
  type?: string
  coords?: Coords 
  zipcode?: string
}

export const parseLocationQueryString = (route: Maybe<GenericRoute>) => {
  if (!route) return ''

  const { address, city, coords, zipcode } = route
  
  if(coords && coords.lat && coords.long) {
    return `${coords.lat}+${coords.long}&travelmode=driving`
  }

  return `${address}+${city}+${zipcode}&travelmode=driving`
}